// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_48fb9921","outerContainer":"_9c455241","secondaryToolbar":"_9e8f8e87","doorHangerRight":"_4c475402","toolbarContainer":"_6a5f6638","toolbarViewerMiddle":"_0b86597e","progressBar":"a3267f11","back-to-application":"_4bf114e7","modal":"fb327cdd","popup":"_71bff2b7","row":"f266985a","rowMb":"a37aeb3d","applyBtn":"_5160feaf","select":"_6082c22e","title":"_1281eea9","titleDanger":"_82c5c77b","text":"_14276e5b","btns":"_5eedd7f2","video":"e3c99598"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/Components/MediaSettings/styles.styl
// module id = 722
// module chunks = 39